export default __webpack_public_path__ + "static/media/banner2.05359413.webp";